import { useAuth0 } from '@auth0/auth0-react'
import { useCallback } from 'react'

const keys = [
    'access_token',
    'dashboard_filter_value',
    'alertId',
    'userOrganizationId',
    'saved_time_preset',
    'saved_time_range',
    'report_table_columns',
    'report_table_pagination_position',
    'report_table_bordered',
    'report_table_ellipsis',
    'dateRange',
    'asset_page_incident_table_columns',
    'asset_page_incident_table_pagination_position',
    'asset_page_incident_table_bordered',
    'asset_page_incident_table_ellipsis',
    'incident:expandAllStages',
    'incident_filter_value',
    'incident_table_columns',
    'simulation_table_columns',
    'incident_table_pagination_position',
    'incident_table_bordered',
    'tabulator-alert_incident_table-group',
    'isMultiTaskCompletionModalDisable',
    'userOrganizations',
    'team_filter_value',
    'team_table_columns',
    'team_table_pagination_position',
    'team_table_bordered',
    'team_table_ellipsis',
    'bannerCancelConfig',
    'alert_table_columns',
    'alert_table_pagination_position',
    'alert_table_bordered',
    'alert_table_ellipsis',
    'role_table_columns',
    'role_table_pagination_position',
    'role_table_bordered',
    'role_table_ellipsis',
    'vulnerability_table_columns',
    'vulnerability_table_pagination_position',
    'vulnerability_table_bordered',
    'vulnerability_table_ellipsis',
    'alerts_page_current_view',
    'hide_alerts_group_with_zero',
    'select-user-for-alert-export',
    'asset_table_pagination_position',
    'asset_table_bordered',
    'asset_table_ellipsis',
    'criticality_filter_value',
    'criticality_custom_filter_value',
    'artifact_filter_value',
    'alert_dashboard_view_value',
    'redirectFromSignup',
    'sidebarCollapsed',
]

const useLogout = () => {
    const { logout: auth0Logout } = useAuth0()

    const logout = useCallback(() => {
        /**
         * Clear all user specific local storage keys
         */

        for (let key of keys) {
            localStorage.removeItem(key)
        }

        auth0Logout({
            logoutParams: {
                returnTo: window.location.origin,
            },
        })
    }, [auth0Logout])

    return logout
}

export default useLogout
